export default __webpack_public_path__ + "1a4d80e8e3b0c65f6f85c5fabbb373f3.jpg";